import TambahSPK from './TambahSPK';

export default TambahSPK